<div class="quoteModel">
  <div class="cx-modal-content">
    <h4 class="modelH">
      {{ "welcomePackage.itemAddCartHeader" | cxTranslate }}
    </h4>
    <div class="content">
      <p>{{ "welcomePackage.addedItemPara" | cxTranslate }}</p>
    </div>
    <div class="cstmBtn">
      <span class="link" (click)="navigateToCart()">{{ "welcomePackage.viewQuoteCart" | cxTranslate }}</span>
      <button class="vs-primary-btn sample-btn" (click)="dismissModal()">
        <span>{{ "welcomePackage.contShopingbBtn" | cxTranslate }}</span>
      </button>
    </div>
  </div>
</div>
